import { forwardRef } from 'react'

const Textarea = forwardRef(({ 
  className = '', 
  error, 
  rows = 3,
  ...props 
}, ref) => {
  const baseClasses = 'block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm resize-vertical'
  const errorClasses = error ? 'border-red-300 focus:ring-red-500 focus:border-red-500' : ''
  const combinedClasses = `${baseClasses} ${errorClasses} ${className}`.trim()

  return (
    <div>
      <textarea
        ref={ref}
        rows={rows}
        className={combinedClasses}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  )
})

Textarea.displayName = 'Textarea'

export default Textarea



